import React from 'react';
import Datetime from 'react-datetime';
import map from 'lodash/map';
import {
    Button,
    Col,
    ControlLabel,
    Form,
    FormGroup,
    FormControl,
    Panel,
    Row,
} from 'react-bootstrap';
import { SEVERITIES, I18N, ABNORMALITY_STATUSES } from '../../../../constants';
import { searchFormHasValues } from '../../../../shared/utils/search';

export default class DelaySearch extends React.Component {
    render() {
        const {
            search,
            isFetching = false,
            handleChange,
            handleDateChange,
            handleSubmit,
            handleReset,
        } = this.props;

        return (
            <Panel collapsible defaultExpanded={searchFormHasValues(search)} header={'Search'}>
                <Form horizontal onSubmit={handleSubmit}>
                    <Row style={{ marginBottom: 5 }}>
                        <Col sm={3} className="no-gutter">
                            <FormGroup controlId="name">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Delay name
                                </Col>
                                <Col sm={6}>
                                    <FormControl
                                        type="text"
                                        maxLength="1000"
                                        name="name"
                                        value={search.name}
                                        placeholder="..."
                                        onChange={handleChange}
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="abnormalityDate">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Abnormality date
                                </Col>
                                <Col sm={6}>
                                    <Datetime
                                        name="abnormalityDate"
                                        value={search.abnormalityDate}
                                        onChange={handleDateChange('abnormalityDate')}
                                        dateFormat="DD-MM-YYYY"
                                        timeFormat={false}
                                        inputProps={{
                                            maxLength: 255,
                                            placeholder: '...',
                                        }}
                                        closeOnSelect
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="routeCode">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Route code
                                </Col>
                                <Col sm={6}>
                                    <FormControl
                                        type="text"
                                        maxLength="1000"
                                        name="routeCode"
                                        value={search.routeCode}
                                        placeholder="..."
                                        onChange={handleChange}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col sm={3} className="no-gutter">
                            <FormGroup controlId="runDate">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Run date
                                </Col>
                                <Col sm={6}>
                                    <Datetime
                                        name="runDate"
                                        value={search.runDate}
                                        onChange={handleDateChange('runDate')}
                                        dateFormat="DD-MM-YYYY"
                                        timeFormat={false}
                                        inputProps={{
                                            maxLength: 255,
                                            placeholder: '...',
                                        }}
                                        closeOnSelect
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="destination">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Destination
                                </Col>
                                <Col sm={6}>
                                    <FormControl
                                        type="text"
                                        maxLength="1000"
                                        name="destination"
                                        value={search.destination}
                                        placeholder="..."
                                        onChange={handleChange}
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="delay">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Delay
                                </Col>
                                <Col sm={6}>
                                    <FormControl
                                        type="text"
                                        maxLength="1000"
                                        name="delay"
                                        value={search.delay}
                                        placeholder="..."
                                        onChange={handleChange}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col sm={3} className="no-gutter">
                            <FormGroup controlId="severity">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Severity
                                </Col>
                                <Col sm={6}>
                                    <FormControl
                                        componentClass="select"
                                        name="severity"
                                        value={search.severity}
                                        onChange={handleChange}
                                    >
                                        <option value="">...</option>
                                        {map(SEVERITIES, a => (
                                            <option key={a} value={a}>
                                                {I18N.SEVERITY[a]}
                                            </option>
                                        ))}
                                    </FormControl>
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="abnormalityStatus">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Status
                                </Col>
                                <Col sm={6}>
                                    <FormControl
                                        componentClass="select"
                                        name="abnormalityStatus"
                                        value={search.abnormalityStatus}
                                        onChange={handleChange}
                                    >
                                        <option value="">...</option>
                                        {map(ABNORMALITY_STATUSES, s => (
                                            <option key={s} value={s}>
                                                {I18N.ABNORMALITY_STATUS[s]}
                                            </option>
                                        ))}
                                    </FormControl>
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="tlmsUpdate">
                                <Col componentClass={ControlLabel} sm={5}>
                                    TLMS update
                                </Col>
                                <Col sm={6}>
                                    <FormControl
                                        componentClass="select"
                                        name="tlmsUpdate"
                                        value={search.tlmsUpdate}
                                        placeholder="..."
                                        onChange={handleChange}
                                    >
                                        <option value="">...</option>
                                        <option value="VALIDATE">
                                            {I18N.TLMS_UPDATE.VALIDATE}
                                        </option>
                                    </FormControl>
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col sm={3} className="no-gutter">
                            <FormGroup controlId="assigneeGroup">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Assignee group
                                </Col>
                                <Col sm={6}>
                                    <FormControl
                                        type="text"
                                        maxLength="1000"
                                        name="assigneeGroup"
                                        value={search.assigneeGroup}
                                        placeholder="..."
                                        onChange={handleChange}
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="assignee">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Assignee
                                </Col>
                                <Col sm={6}>
                                    <FormControl
                                        type="text"
                                        maxLength="1000"
                                        name="assignee"
                                        value={search.assignee}
                                        placeholder="..."
                                        onChange={handleChange}
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup>
                                <Col sm={3} smOffset={5}>
                                    <Button
                                        type="submit"
                                        style={{ width: '100%' }}
                                        bsStyle="primary"
                                        disabled={isFetching}
                                    >
                                        {isFetching ? '...' : 'Search'}
                                    </Button>
                                </Col>
                                <Col sm={3}>
                                    <Button
                                        type="reset"
                                        style={{ width: '100%' }}
                                        disabled={isFetching}
                                        onClick={handleReset}
                                    >
                                        Reset
                                    </Button>
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>
                </Form>
            </Panel>
        );
    }
}
